const FeatureIntro = ({ children }) => {
    return (
        <div className="text-gray-500 max-w-2xl mb-6 text-base">{children}</div>
    );
};

export default FeatureIntro;
